import { FC } from 'react';

import { IcStopPollIcon } from '@gem/icons';
import { IconView, MenuItem, MenuItemStyle } from '@gem/ui-kit';

interface ISessionsTerminateButtonProps {
  onClick(): void;
  children: string;
  isDisabled?: boolean;
}

export const SessionsTerminateButton: FC<ISessionsTerminateButtonProps> = (props) => {
  const { onClick, children } = props;
  return (
    <MenuItem
      isDisabled={props.isDisabled}
      size="medium-2"
      style={MenuItemStyle.BrandPrimary}
      onClick={onClick}
      icon={<IconView Icon={IcStopPollIcon} />}
      title={children}
    />
  );
};
